import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react'
import axios from 'axios';
import { navigate } from "@reach/router";
import logger from './lib/logger'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-theme.css'
import App from './App';
import * as serviceWorker from './serviceWorker';
import { RootStore } from './stores/.'
const log = logger()

ReactDOM.render(<Provider store={new RootStore(axios, navigate, log)}><App/></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
